import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule, ButtonSeverity } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MatIcon } from '../mat-icon/mat-icon';

@Component({
  selector: 'reactive-button',
  imports: [ButtonModule, TooltipModule, MatIcon],
  templateUrl: './reactive-icon-text-button.html',
  styleUrl: './reactive-icon-text-button.scss',
})
export class ReactiveIconTextButton {
  @Input() label: string;
  @Input() icon: string;
  @Input() iconPos: string;
  @Input() severity: ButtonSeverity;
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() rounded: boolean = false;
  @Input() raised: boolean = false;
  @Input() variant: 'outlined' | 'text' | undefined = undefined;
  @Input() badge: string | undefined = undefined;
  @Input() badgeSeverity:
    | 'success'
    | 'info'
    | 'warn'
    | 'danger'
    | 'help'
    | 'primary'
    | 'secondary'
    | 'contrast'
    | null
    | undefined = 'secondary';
  @Input() size: 'small' | 'large' | undefined = undefined;
  @Input() tooltipPos: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  /**
   * Callback to execute when button is clicked.
   * This event is intended to be used with the <p-button> component. Using a regular <button> element, use (click).
   * @param {MouseEvent} event - Mouse event.
   * @group Emits
   */
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  /**
   * Callback to execute when button is focused.
   * This event is intended to be used with the <p-button> component. Using a regular <button> element, use (focus).
   * @param {FocusEvent} event - Focus event.
   * @group Emits
   */
  @Output() onFocus: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  /**
   * Callback to execute when button loses focus.
   * This event is intended to be used with the <p-button> component. Using a regular <button> element, use (blur).
   * @param {FocusEvent} event - Focus event.
   * @group Emits
   */
  @Output() onBlur: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
}
